export const transformBookDealsData = async (components) => {
  return components.map((component) => {
    if (component.type === "book-listicle-info") {
      const { description, affiliate, salePrice, country, freevoice } = component.props;
      let currencySymbol = "$";
      if (country && country.symbol) currencySymbol = country.symbol;
      return {
        id: component.id || component.props?.id || null, // Preserve component id for deduplication
        title: affiliate?.props?.title || "Unknown Title",
        description: description?.props?.value
          ? description.props.value.replace(/&nbsp;/g, " ")
          : "",
        authors: Array.isArray(affiliate?.props?.authors)
          ? affiliate.props.authors.map((x) => x.Display_Name || x.display_name).join(", ")
          : affiliate?.props?.authors || "",
        isbn: affiliate?.props?.primary_isbn || "N/A",
        image: affiliate?.props?.image?.props?.image?.Name || "",
        promoPrice: currencySymbol + salePrice?.props?.value?.replace(/<[^>]*>/g, "") || 0.0, // Remove HTML tags
        dlp: currencySymbol + (affiliate?.props?.price || 0.0),
        pub_date: affiliate?.props?.pub_date || null,
        publisher: affiliate?.props?.publisher || "",
        freevoice: freevoice,
        retailerLinks: Object.fromEntries(
          Object.entries({
            Amazon: affiliate?.props?.amazonLink,
            Apple: affiliate?.props?.itunesLink,
            BN: affiliate?.props?.bnLink,
            "Bookshop.org": affiliate?.props?.bookShopLink,
            Google: affiliate?.props?.googleLink,
            Kobo: affiliate?.props?.koboLink,
            BAM: affiliate?.props?.bamLink,
          }).filter(([, url]) => url) // ✅ Remove null/undefined links
        ),
        previewLink:
          affiliate?.props?.urlType === "Internal Link"
            ? `/books/${affiliate.props.primary_isbn}`
            : null,
        latestRating: affiliate?.props?.latestRating,
        currentRank: affiliate?.props?.currentRank,
        latestReviews: affiliate?.props?.latestReviews,
        category: affiliate?.props.customCategoryNames?.join(","),
        type: component.type,
        isPromotedToKindleDeals: affiliate?.props?.isPromotedToKindleDeals,
      };
    } else {
      return component;
    }
  });
};
